import 'css-chunksrc/feature/gift-card/GiftCardAddToCheckModal.module.scss';export default {
  "content": "GiftCardAddToCheckModal_content",
  "currency-input": "GiftCardAddToCheckModal_currency-input"
};